import moment from 'moment';
import {
  currentPresetColumnsList,
  filteredData,
  isAllColumnsSelected,
  selectedPreset
} from './statistics.selectors';

const columns = [
  {
    name: 'panel_id',
    label: 'Панель',
    width: 75,
    isSelected: true,
    sectionId: 'section_1'
  },
  {
    name: 'type',
    label: 'Тип',
    width: 75,
    isSelected: true,
    sectionId: 'section_1'
  },
  {
    name: 'from',
    label: 'От',
    width: 75,
    isSelected: true,
    sectionId: 'section_1'
  },
  {
    name: 'to',
    label: 'Кому',
    width: 75,
    isSelected: true,
    sectionId: 'section_1'
  },
  {
    name: 'date',
    label: 'Дата',
    width: 100,
    isSelected: true,
    sectionId: 'section_1'
  },
  {
    name: 'amount',
    label: 'Сумма',
    width: 75,
    isSelected: true,
    sectionId: 'section_1'
  },
  {
    name: 'site',
    label: 'Сайт',
    width: 75,
    isSelected: true,
    sectionId: 'section_1'
  },
  {
    name: 'total_credits',
    label: 'Всего кредитов',
    width: 110,
    isSelected: true,
    sectionId: 'section_1'
  },
  {
    name: 'our_credits',
    label: 'Наши кредитов',
    width: 110,
    isSelected: true,
    sectionId: 'section_1'
  },
  {
    name: 'our_$',
    label: 'Наши $',
    width: 75,
    isSelected: true,
    sectionId: 'section_1'
  }
];

export const statisticsInitialState = {
  statistics: {
    data: [],
    ui: {
      favorites: []
    },
    meta: {
      isLoading: false,
      hasError: false,
      loaded: false,
      in_process: null,
    },
    filters: {
      startDate: moment().utc(),
      endDate: moment().utc(),
      columnSettings: {
        currentPresetId: 0,
        availablePresets: [
          {
            id: 0,
            label: 'по умолчанию',
            columnsConfiguration: columns
          }
        ],
        lastSelectedPresetColumns: []
      },
      search: ''
    },
    selectors: {
      filteredData,
      isAllColumnsSelected,
      selectedPreset,
      currentPresetColumnsList
    }
  }
};
